import PropTypes from 'prop-types';

import { ICONS_ALIASES } from '_constants/icons';
import ArrowDownSvg from './assets/ArrowDownSvg';
import ArrowUpSvg from './assets/ArrowUpSvg';
import ArrowLeftSvg from './assets/ArrowLeftSvg';
import ArrowRightSvg from './assets/ArrowRightSvg';
import ChevronUpSvg from './assets/ChevronUpSvg';
import ChevronDownSvg from './assets/ChevronDownSvg';
import CheckSvg from './assets/CheckSvg';
import CheckRoundedSvg from './assets/CheckRoundedSvg';
import CloseSvg from './assets/CloseSvg';
import EditSvg from './assets/EditSvg';
import LinkSvg from './assets/LinkSvg';
import MinusSvg from './assets/MinusSvg';
import MoreSvg from './assets/MoreSvg';
import PlusSvg from './assets/PlusSvg';
import SmsSvg from './assets/SmsSvg';
import StepSvg from './assets/StepSvg';
import StepDoneSvg from './assets/StepDoneSvg';
import RadioOnSvg from './assets/RadioOnSvg';
import RadioOffSvg from './assets/RadioOffSvg';
import FacebookSvg from './assets/FacebookSvg';
import TwitterSvg from './assets/TwitterSvg';
import LinkedinSvg from './assets/LinkedinSvg';
import PhoneSvg from './assets/PhoneSvg';
import SearchSvg from './assets/SearchSvg';
import TrashSvg from './assets/TrashSvg';
import LockSvg from './assets/LockSvg';
import ShieldSvg from './assets/ShieldSvg';
import ShieldTickSvg from './assets/ShieldTickSvg';
import UploadSvg from './assets/UploadSvg';
import PopularSvg from './assets/PopularSvg';
import RecommendSvg from './assets/RecommendSvg';
import ArrowTwoToneLeftSvg from './assets/ArrowTwoToneLeftSvg';
import TickSvg from './assets/TickSvg';
import SaveAddSvg from './assets/SaveAddSvg';
import PeopleSvg from './assets/PeopleSvg';
import SearchNormalSvg from './assets/SearchNormalSvg';
import ArchiveSvg from './assets/ArchiveSvg';
import CoinSvg from './assets/CoinSvg';
import DocumentSvg from './assets/DocumentSvg';
import ClockSvg from './assets/ClockSvg';
import SmsEditSvg from './assets/SmsEditSvg';
import SearchZoomInSvg from './assets/SearchZoomInSvg';
import DeviceMessageSvg from './assets/DeviceMessageSvg';
import ArrowSquareRightSvg from './assets/ArrowSquareRightSvg';
import ArrowSquareLeftSvg from './assets/ArrowSquareLeftSvg';
import SendSvg from './assets/SendSvg';
import CallCallingSvg from './assets/CallCallingSvg';
import MessageTextSvg from './assets/MessageTextSvg';
import ArrowUpMainSvg from './assets/ArrowUpMainSvg';

const icons = {
  [ICONS_ALIASES.archive]: ArchiveSvg,
  [ICONS_ALIASES.arrowLeft]: ArrowLeftSvg,
  [ICONS_ALIASES.arrowSquareLeft]: ArrowSquareLeftSvg,
  [ICONS_ALIASES.arrowTwoToneLeft]: ArrowTwoToneLeftSvg,
  [ICONS_ALIASES.arrowRight]: ArrowRightSvg,
  [ICONS_ALIASES.arrowSquareRight]: ArrowSquareRightSvg,
  [ICONS_ALIASES.arrowDown]: ArrowDownSvg,
  [ICONS_ALIASES.arrowUp]: ArrowUpSvg,
  [ICONS_ALIASES.arrowUpMain]: ArrowUpMainSvg,
  [ICONS_ALIASES.chevronUp]: ChevronUpSvg,
  [ICONS_ALIASES.chevronDown]: ChevronDownSvg,
  [ICONS_ALIASES.check]: CheckSvg,
  [ICONS_ALIASES.checkRounded]: CheckRoundedSvg,
  [ICONS_ALIASES.callCalling]: CallCallingSvg,
  [ICONS_ALIASES.close]: CloseSvg,
  [ICONS_ALIASES.clock]: ClockSvg,
  [ICONS_ALIASES.coin]: CoinSvg,
  [ICONS_ALIASES.deviceMessage]: DeviceMessageSvg,
  [ICONS_ALIASES.document]: DocumentSvg,
  [ICONS_ALIASES.edit]: EditSvg,
  [ICONS_ALIASES.link]: LinkSvg,
  [ICONS_ALIASES.lock]: LockSvg,
  [ICONS_ALIASES.messageText]: MessageTextSvg,
  [ICONS_ALIASES.minus]: MinusSvg,
  [ICONS_ALIASES.more]: MoreSvg,
  [ICONS_ALIASES.people]: PeopleSvg,
  [ICONS_ALIASES.plus]: PlusSvg,
  [ICONS_ALIASES.phone]: PhoneSvg,
  [ICONS_ALIASES.saveAdd]: SaveAddSvg,
  [ICONS_ALIASES.search]: SearchSvg,
  [ICONS_ALIASES.searchNormal]: SearchNormalSvg,
  [ICONS_ALIASES.searchZoomIn]: SearchZoomInSvg,
  [ICONS_ALIASES.send]: SendSvg,
  [ICONS_ALIASES.shield]: ShieldSvg,
  [ICONS_ALIASES.shieldTick]: ShieldTickSvg,
  [ICONS_ALIASES.sms]: SmsSvg,
  [ICONS_ALIASES.smsEdit]: SmsEditSvg,
  [ICONS_ALIASES.step]: StepSvg,
  [ICONS_ALIASES.stepDone]: StepDoneSvg,
  [ICONS_ALIASES.radioOn]: RadioOnSvg,
  [ICONS_ALIASES.radioOff]: RadioOffSvg,
  [ICONS_ALIASES.facebook]: FacebookSvg,
  [ICONS_ALIASES.twitter]: TwitterSvg,
  [ICONS_ALIASES.trash]: TrashSvg,
  [ICONS_ALIASES.upload]: UploadSvg,
  [ICONS_ALIASES.linkedin]: LinkedinSvg,
  [ICONS_ALIASES.popular]: PopularSvg,
  [ICONS_ALIASES.recommend]: RecommendSvg,
  [ICONS_ALIASES.tick]: TickSvg,
};

const Icon = ({ alias, color, width, height }) => {
  const Icon = icons[alias];

  if (!Icon) {
    return null;
  }

  return <Icon color={color} width={width} height={height} />;
};

Icon.propTypes = {
  alias: PropTypes.oneOf([
    ICONS_ALIASES.archive,
    ICONS_ALIASES.arrowDown,
    ICONS_ALIASES.arrowUp,
    ICONS_ALIASES.arrowUpMain,
    ICONS_ALIASES.arrowLeft,
    ICONS_ALIASES.arrowSquareLeft,
    ICONS_ALIASES.arrowTwoToneLeft,
    ICONS_ALIASES.arrowRight,
    ICONS_ALIASES.arrowSquareRight,
    ICONS_ALIASES.callCalling,
    ICONS_ALIASES.chevronUp,
    ICONS_ALIASES.chevronDown,
    ICONS_ALIASES.check,
    ICONS_ALIASES.checkRounded,
    ICONS_ALIASES.close,
    ICONS_ALIASES.clock,
    ICONS_ALIASES.coin,
    ICONS_ALIASES.document,
    ICONS_ALIASES.deviceMessage,
    ICONS_ALIASES.edit,
    ICONS_ALIASES.link,
    ICONS_ALIASES.lock,
    ICONS_ALIASES.messageText,
    ICONS_ALIASES.minus,
    ICONS_ALIASES.more,
    ICONS_ALIASES.plus,
    ICONS_ALIASES.people,
    ICONS_ALIASES.phone,
    ICONS_ALIASES.saveAdd,
    ICONS_ALIASES.search,
    ICONS_ALIASES.searchNormal,
    ICONS_ALIASES.searchZoomIn,
    ICONS_ALIASES.send,
    ICONS_ALIASES.shield,
    ICONS_ALIASES.shieldTick,
    ICONS_ALIASES.sms,
    ICONS_ALIASES.smsEdit,
    ICONS_ALIASES.step,
    ICONS_ALIASES.stepDone,
    ICONS_ALIASES.radioOn,
    ICONS_ALIASES.radioOff,
    ICONS_ALIASES.facebook,
    ICONS_ALIASES.twitter,
    ICONS_ALIASES.trash,
    ICONS_ALIASES.upload,
    ICONS_ALIASES.linkedin,
    ICONS_ALIASES.popular,
    ICONS_ALIASES.recommend,
    ICONS_ALIASES.tick,
  ]),
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Icon;
